export default __webpack_public_path__ + "static/media/ardashirfort.e95a55a9.jpg";